(ns renolit-roofing-service.view.service.service-information-view
  (:require [renolit-roofing-service.layout.components :refer [entity-section]]
            [renolit-roofing-service.layout.display-item :as layout.display-item]
            [renolit-roofing-service.shared.util.time :as util.time]
            [renolit-roofing-service.util.localization :as util.localization]))

(def ^:const view-context
  :service-details-view-service-information)

(defn field-value-view
  [label-transl-kw value]
  [layout.display-item/main
   {:type :text
    :value value
    :label-transl-kw label-transl-kw}])

(defn- service-basic-data
  [service]
  (let [{:keys [name origin reason reason-text objective manager authorized-diagnostic-contractor inspector last-diagnosis-date last-maintenance-date]} service]
    [:div.service-section.service-section--half
     [field-value-view :domain.service/name name]
     [field-value-view :domain.service/origin (util.localization/dropdown-value :service-origin origin)]
     [field-value-view :domain.service/reason (util.localization/dropdown-value :service-reason reason)]
     [field-value-view :domain.service/reason-text reason-text]
     [field-value-view :domain.service/objective objective]
     [field-value-view :domain.service/manager manager]
     [field-value-view :domain.service/contractor authorized-diagnostic-contractor]
     [field-value-view :domain.service/inspector inspector]
     [field-value-view :domain.service/last-diagnosis-date (util.time/format-date last-diagnosis-date {})]
     [field-value-view :domain.service/last-maintenance-date (util.time/format-date last-maintenance-date {})]]))

(defn- client-information
  [service]
  (let [{:keys [customer-name customer-profile company-owner company-industry]} service]
    [:div.service-section.service-section--half
     [field-value-view :domain.client/name customer-name]
     [field-value-view :domain.client/profile [util.localization/dropdown-value :customer-profile customer-profile]]
     [field-value-view :domain.client/company-owner company-owner]
     [field-value-view :domain.client/company-industry company-industry]]))

(defn- building-information
  [service]
  (let [{:keys [building-height roof-slope upstand service-area]} service]
    [:div.service-section.service-section--half
     [field-value-view :domain.building/height building-height]
     [field-value-view :domain.building/inclination roof-slope]
     [field-value-view :domain.building/upstand upstand]
     [field-value-view :domain.building/surface service-area]]))

(defn- roof-structure
  [service]
  (let [{:keys [roofing-membrane application-method support protective-glue vapor-barrier glue-type thermal-insulation separation-layer color fixation]} service]
    [:div.service-section.service-section--full
     [field-value-view :domain.roof/membrane roofing-membrane]
     [field-value-view :domain.roof/application-method application-method]
     [field-value-view :domain.roof/support support]
     [field-value-view :domain.roof/protective-glue protective-glue]
     [field-value-view :domain.roof/vapor-barrier vapor-barrier]
     [field-value-view :domain.roof/glue-type glue-type]
     [field-value-view :domain.roof/thermal-insulation thermal-insulation]
     [field-value-view :domain.roof/separation-layer separation-layer]
     [field-value-view :domain.roof/color color]
     [field-value-view :domain.roof/fixation fixation]]))

(defn main
  [service]
  [:div.service-form
   [:<>
    [entity-section
     {:title-transl-kw :page.service.add.service-data}
     [service-basic-data service]]
    [:div.service-section.service-section--half
     [entity-section
      {:title-transl-kw :page.service.add.customer-data}
      [client-information service]]
     [entity-section
      {:title-transl-kw :page.service.add.building-information}
      [building-information service]]]
    [entity-section
     {:title-transl-kw :page.service.add.roof-structure}
     [roof-structure service]]]])
